import { serverTimestamp,addDoc, updateDoc, writeBatch, setDoc, doc, getDoc, getDocs, query, where, arrayUnion, arrayRemove, collection, getCountFromServer } from "firebase/firestore";
import { updateProfile } from "firebase/auth";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";
import { storage } from "../firebase/config.js";
import { db } from "../firebase/config.js";
import imageCompression from "browser-image-compression";

export async function getAllUsers() {
    try {
        const querySnapshot = await getDocs(collection(db, "users"));
        const allUsers = []
        querySnapshot.forEach((doc) => {
            allUsers.push({ id: doc.id, ...doc.data() })
        });
        return { success: true, users: allUsers };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}


export async function getAllUsersWithCommunityId(communityId) {
    try {

        const usersSnapshot = await getDocs(collection(db, 'users'));
        const usersInCommunity = [];

        for (const userDoc of usersSnapshot.docs) {
            const communityRef = doc(db, `users/${userDoc.id}/communities/${communityId}`);
            const communityDoc = await getDoc(communityRef);

            if (communityDoc.exists()) {
                usersInCommunity.push({ id: userDoc.id, ...userDoc.data() });
            }
        }

        return { success: true, users: usersInCommunity };
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function createUserIfNotExists(user) {
    const userRef = doc(db, "users", user.uid);
    const userSnap = await getDoc(userRef);

    if (!userSnap.exists()) {
        await setDoc(userRef, {
            uid: user.uid,
            name: user.displayName,
            email: user.email,
            createdAt: serverTimestamp(),
            photoURL: user.photoURL,
            role: "user", // or whatever fits your app
        });
        //add user data to local storage
        const res = await getUserById(user.uid)
        if (res.success) {
            localStorage.setItem("userData", JSON.stringify(res.userData))
        }
    }
};

export async function getUserById(userId) {
    try {
        const docRef = doc(db, "users", userId);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
            // console.log("Document data:", docSnap.data());
            return { success: true, userData: docSnap.data() };
        } else {
            // docSnap.data() will be undefined in this case
            console.log("No such document!");
            return { success: false, userData: {} };

        }
    } catch (error) {
        console.error('Error getting request:', error);
        return { success: false, error: error.message };
    }
}

export async function updateFavourites(userId, favouriteId, add) {
    try {
        // Create an initial document to update.
        const userDocRef = doc(db, "users", userId);
        // To update age and favorite color:
        if (add) {
            await updateDoc(userDocRef, {
                favourites: arrayUnion(favouriteId)
            });

        } else {
            await updateDoc(userDocRef, {
                favourites: arrayRemove(favouriteId)
            });
        }
        return { success: true, added: add };
    } catch (error) {
        console.error('Error adding Order:', error);
        return { success: false, error: error.message };
    }
}

export async function joinEvent(user, eventProps) { //on user click 'join event/meetup'
    try {
        if (!user) throw new Error("User not authenticated");
        const eventId = eventProps.id
        const batch = writeBatch(db);

        const userJoinedEventRef = doc(db, "users", user.uid, "events", eventId);
        const eventAttendeeRef = doc(db, "events", eventId, "players", user.uid);

        // Set minimal or custom data in each direction
        batch.set(userJoinedEventRef, {
            coverImage: eventProps.coverImage,
            title: eventProps.title,
            connectionType: eventProps.connectionType,
            joinedAt: serverTimestamp(),
        });

        batch.set(eventAttendeeRef, {
            name: user.displayName,
            photoURL: user.photoURL,
            joinedAt: serverTimestamp(),
        });

        await batch.commit();
        return { success: true }
    } catch (error) {
        console.error("Join event failed:", error);
        return { success: false }
    }
};


export async function unjoinEvent(user, eventProps) {
    try {
        if (!user) throw new Error("User not authenticated");
        const eventId = eventProps.id;
        const batch = writeBatch(db);

        const userJoinedEventRef = doc(db, "users", user.uid, "events", eventId);
        const eventAttendeeRef = doc(db, "events", eventId, "players", user.uid);

        // Remove the joined event references in both directions
        batch.delete(userJoinedEventRef);
        batch.delete(eventAttendeeRef);

        await batch.commit();
        return { success: true };
    } catch (error) {
        console.error("Unjoin event failed:", error);
        return { success: false };
    }
}

export async function getUserEvents(userId) { //get events joined by user 
    const joinedEventsRef = collection(db, "users", userId, "events");
    const snapshot = await getDocs(joinedEventsRef);
    return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
}

// export async function uploadProfilePicture(file, user) { //update user profile picture
//     if (!user) throw new Error("No authenticated user");
//     const storageRef = ref(storage, `profilePictures/${user.uid}/${file.name}`);
//     // Upload file to Firebase Storage
//     await uploadBytes(storageRef, file);
//     // Get download URL
//     const photoURL = await getDownloadURL(storageRef);
//     return photoURL;
// }

export async function uploadProfilePicture(file, user) {
    if (!user) throw new Error("No authenticated user");

    // 🔹 Compress image BEFORE upload
    const compressedFile = await imageCompression(file, {
        maxWidthOrHeight: 1080,
        maxSizeMB: 0.5,
        useWebWorker: true,
    });

    const storageRef = ref(storage, `profilePictures/${user.uid}.jpg`);

    await uploadBytes(storageRef, compressedFile, {
        contentType: 'image/jpeg',
    });

    const photoURL = await getDownloadURL(storageRef);
    return photoURL;
}

export async function changeDisplayName(displayName, user) { //update user profile displayName
    if (!user) throw new Error("No authenticated user");
    // Update Firebase Auth profile
    await updateProfile(user, { displayName });
    return { success: true };
}


export async function changeUserBio(bio, userId) {
    try {
        const userDocRef = doc(db, "users", userId);
        await updateDoc(userDocRef, {
            bio: bio
        });
        return { success: true };
    } catch (error) {
        console.error('Error adding Order:', error);
        return { success: false, error: error.message };
    }
}

export async function getUsersCount() {
    try {
        const coll = collection(db, "users");
        const snapshot = await getCountFromServer(coll);
        const count = snapshot.data().count
        return { success: true, count };
    } catch (error) {
        console.error('Error getting count:', error);
        return { success: false, error: error.message };
    }
}

export async function copyFirestoreDocument(
    sourceCollection,
    sourceDocId,
    targetCollection,
    targetDocId
) {
    try {
        const sourceRef = doc(db, sourceCollection, sourceDocId);
        const sourceSnap = await getDoc(sourceRef);

        if (!sourceSnap.exists()) {
            throw new Error("Source document does not exist");
        }

        const sourceData = sourceSnap.data();

        const targetRef = doc(db, targetCollection, targetDocId);
        await setDoc(targetRef, {
            ...sourceData,
            copiedFrom: sourceDocId,
            copiedAt: new Date(),
        });

        return { success: true };
    } catch (error) {
        console.error("Error copying document:", error);
        return { success: false, error };
    }
}


export async function getExerciseTypes() {
    try {
        const snapshot = await getDocs(collection(db, 'exerciseTypes'));
        const types = snapshot.docs
            .map(doc => ({ id: doc.id, ...doc.data() }))
            .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
        return { success: true, exerciseTypes: types };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

export async function changeUserPreferences(userId, updates) {
    try {
        const userDocRef = doc(db, 'users', userId);
        await updateDoc(userDocRef, updates);
        const userData = JSON.parse(localStorage.getItem('userData'));
        localStorage.setItem('userData', JSON.stringify({ ...userData, ...updates }));
        return { success: true };
    } catch (error) {
        return { success: false, error: error.message };
    }
}

export async function createNotification(props) {
    try {
        await addDoc(collection(db, 'notifications'), {
            ...props,
            createdAt: serverTimestamp(),
        });
        console.log('Notification created!');
        return true;
    } catch (error) {
        console.error('createNotification ER:', error);
        return false;
    }
}